import axios from 'axios'
import { Loading } from 'element-ui';

// 添加一个请求拦截器
let loadingInstance
axios.interceptors.request.use(function (config) {
    //在请求发出之前进行一些操作
    console.log('axios.interceptors.request', config);
    loadingInstance = Loading.service({ text: 'loading...', customClass: 'loadcss' });
    return config;
}, function (err) {
    //Do something with request error
    console.log('请求异常');
    // return Promise.reject(error);
});
//添加一个响应拦截器
axios.interceptors.response.use(function (res) {
    //在这里对返回的数据进行处理
    console.log('axios.interceptors.response', res);
    loadingInstance.close();
    return res;
}, function (err) {
    //Do something with response error
    loadingInstance.close();
    console.log('网络异常');
    return Promise.reject(error);
});


console.log("interceptors声明完毕")


// WEBPACK FOOTER //
// ./src/assets/js/interceptors.js